import {
    apiRequest,
    skillcertificationDetail,
    skillcertificationApprove,
    masterRegion
} from "../../../../../services/adapters/kepegawaian/skillcertificationService"

class UpdateRepository {

    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", skillcertificationDetail, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", skillcertificationApprove, {
            body: query
        }, true)
    }
}

export default UpdateRepository